import React from "react";
import {
	Appbar,
	BottomNavigator,
	LoginAlert,
	Overlay,
	GameAlert,
} from "@components";
import styled from "styled-components";
import HomeRoutes from "./HomeRoutes";
import { useLocation } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { IMG_HOME_BG } from "@assets";
import { NoInternet } from "@pages";

const Container = styled.div`
	min-height: 100vh;
	position: relative;
`;

const Background = styled.img.attrs({
	alt: 'homebg',
	src: IMG_HOME_BG,
})`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: auto;
max-height: 100vh;
`;

const BgLayer3 = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
max-height: 100vh;
background: linear-gradient(180deg, #600F02 18.5%, #C94208 59%, #C96908 97.5%);
opacity: 0.5;
`;

const BgLayer2 = styled(BgLayer3)`
background: #7A2C08;
`;

const BgLayer1 = styled(BgLayer3)`
background: #F09400;
`;

const Home = () => {
	const { pathname } = useLocation();

	if (!navigator.onLine) {
		return <NoInternet />;
	}

	return (
		<>
			<Container>
				{pathname === `/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.GAMES}` && (
					<>
						<Appbar />
						<Background />
						<BgLayer1 />
						<BgLayer2 />
						<BgLayer3 />
					</>
				)}
				<HomeRoutes />
				<BottomNavigator />
			</Container>
			<LoginAlert />
			<Overlay />
			<GameAlert />
		</>
	);
};

export default Home;
